import { ApiEndpoints } from '@/types/routes';
import { IHttpClient } from '@/api/HttpClient';
import { IEntityIdsApi, IGetEntityDetailsRequest } from '@/api/entityIds/entityIds.types';
import { IEntity, IEntityDetailsDto } from '@/types/entities';

export class EntityIdsApi implements IEntityIdsApi {
  private getBaseUrl(): string {
    return ApiEndpoints.ENTITY_IDS;
  }

  constructor(private readonly httpClient: IHttpClient) {}

  getUniqueEntitiesList() {
    return this.httpClient.get<IEntity[]>(`${this.getBaseUrl()}alive`);
  }

  getEntityDetails({ agioId, isBetaUserFeature }: IGetEntityDetailsRequest) {
    const params = {
      ...(isBetaUserFeature ? { isBetaData: isBetaUserFeature } : {}),
    };

    return this.httpClient.get<IEntityDetailsDto>(`${this.getBaseUrl()}${agioId}/details`, {
      params,
    });
  }
}
